import {
  CASHBACK_ADD,
  CASHBACK_CLEAR,
  CASHBACK_CLOSE_MODAL,
  CASHBACK_DELETE,
  CASHBACK_GET_DATA,
  CASHBACK_SET_MODAL,
  CASHBACK_UPDATE_CLIENT,
} from "./cashback-actions";

export default function cashbackReducer(state = null, action) {
  switch (action.type) {
    case CASHBACK_GET_DATA:
      return {
        ...state,
        ...action.data,
      };
    case CASHBACK_CLEAR:
      return null;
    case CASHBACK_SET_MODAL:
      return {
        ...state,
        modal: action.data,
      };
    case CASHBACK_CLOSE_MODAL:
      return {
        ...state,
        modal: null,
      };
    case CASHBACK_UPDATE_CLIENT:
      return {
        ...state,
        modal: null,
        corpo: state.corpo.map((item) => {
          if (item.id === action.data.id) {
            return action.data;
          }
          return item;
        }),
      };
    case CASHBACK_ADD:
      return {
        ...state,
        modal: null,
        corpo: [action.data, ...state.corpo],
      };
    case CASHBACK_DELETE:
      return {
        ...state,
        modal: null,
        corpo: state.corpo.filter((item) => item.id !== action.data),
      };

    default:
      return state;
  }
}
